var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"layler"},_vm._l((_vm.dataatrr),function(item,index){return _c('div',{key:item,staticClass:"celiangitem",class:{active:_vm.changeColor(index),unicolor:_vm.showactive==0,
      border:index==2,border1:index==4,backgroundimg:index==3,},on:{"click":function($event){_vm.selectItem(index)}}},[_vm._v(_vm._s(item))])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d85014aa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modelView/layer.vue
// module id = null
// module chunks = 